import { BaseModel } from "./BaseModel";
import { CalculationHelper, CalculationModel } from "./CalculationHelper";
import { CalcualtionResultKeys, ColumnHeaders, TabNames } from '../modules/Constants';

export class SaleableComparisonModel extends BaseModel {
    overrideFormatSheet() {
        let header = this.Headers;
        let rows = this.Display;
        let columns = Array(rows[0].length).fill(0).map(() => ({ width: 150, numeric: false }));
        let blankRows = header.map((h, index) => { return { index: index, header: h } }).filter(item => item.header === "").map(item => item.index);
        columns[0].width = 300;

        let result = {}
        result.rows = rows.map(
            (row, rowIndex) => {
                let result = {}
                result.cells = columns.map((column, colIndex) => {
                    let cell = {};

                    if (colIndex === 0 && blankRows.includes(rowIndex) === false) {
                        cell = {
                            style: this.defaultHeader(),
                            wrap: true
                        }
                    } else {
                        if (rowIndex >= 9 && colIndex >= 1) {
                            cell = {
                                style: this.defaultCell(),
                                format: '#,##0.00',
                                wrap: true
                            }
                        } else {
                            cell = {
                                style: this.defaultCell(),
                                wrap: true
                            }
                        }
                    }

                    let value = rows[rowIndex][colIndex] ?? "";

                    if (value[0] === '=') {
                        cell.formula = value;
                    } else {
                        cell.value = value;
                    }

                    return cell;
                })
                return result;
            })

        result.columns = columns.map((col) => ({ width: col.width }));

        return result
    }

    constructor() {
        super();
        this.TabName = TabNames.SALEABLE_COMPARISON;
        this.TabIndex = 1;
        this.DataProcessor = new SaleableComparisonProcessor();
        this.formatSheet = this.overrideFormatSheet;
    }

    static SaleableComparisonAcrossOptions() {

        let result = new SaleableComparisonModel();
        result.DataProcessor = new SaleableComparisonAcrossOptionsProccessor();

        return result;
    }
}

export class SaleableComparisonAcrossOptionsProccessor {
    process(data) {

        let headers = [];
        let records = [];
        let numerics = [];

        data.forEach(set => {
            let setData = Object.assign({}, set);
            setData.currency = data.currency;
            setData.returnRecords = true;
            let processor = new SaleableComparisonProcessor();
            let setResult = processor.process(setData);


            headers = setResult.headers;
            numerics = setResult.numerics;
            records = records.concat(setResult.display);
        });

        let helper = new SaleableComparisonProcessor();
        let display = helper.getDisplay(headers, records, data.currency);
        
        let result = {
            headers: headers,
            display: display,
            numerics: numerics
        };

        return result;
    }
}

export class SaleableComparisonProcessor {

    process(data) {
        let Calculations = [];
        let Calcs = data.calculations_parsed[1];
        let ExchangeRates = [];
        let Volumes = [];
        let Records = [];
        let Headers = [];
        let Currency = data.currency;
        let returnRecords = data.returnRecords ?? false;

        let study = data.study;
        let snapshots = data.snapshots;
        let version = data.version;

        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });

        Calcs.forEach(calc => {
            Calculations.push(new CalculationModel(calc.calculationText, calc.calculation, calc.val, calc.amount, ExchangeRates, Currency))
        })

        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                let key = new CalculationHelper().getPartKey(part);
                Volumes[key] = { first: 0, total: 0, years: [] };

                var firstYearIndex = part.CostStudyVolume.Value.Fields[0].Values.findIndex(x => x.Value > 0)
                if (!firstYearIndex || firstYearIndex == -1) {
                    firstYearIndex = 0
                }
                let firstYear = part.CostStudyVolume.Value.Fields[0].Values[firstYearIndex];
                Volumes[key].first = firstYear.Value;
                Volumes[key].firstYear = new Date(firstYear.Date).getUTCFullYear();


                part.CostStudyVolume.Value.Fields.forEach(volume => {
                    volume.Values.forEach(value => {
                        Volumes[key].total += value.Value;
                        var year = new Date(value.Date).getUTCFullYear();
                        Volumes[key].years[year] = (Volumes[key].years[year] ?? 0) + value.Value;
                    });
                });
            });

        });

        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                var model = new SaleableComparisonPartModel(version, snapshot, part, Calculations, Volumes);
                Records.push(model);
            })
        })

        Headers = this.configureHeader();
        let result = {
            headers: Headers,
            display: returnRecords === true ? Records : this.getDisplay(Headers, Records, Currency),
            numerics: this.getNumerics()
        };

        return result;
    }

    configureHeader() {
        let header = [
            "",
            ColumnHeaders.CURRENCY_PREFIX,
            "",
            ColumnHeaders.COST_STUDY,
            ColumnHeaders.VERSION,
            ColumnHeaders.OPTION_NAME,
            ColumnHeaders.SALEABLE_PART_NUMBER,
            ColumnHeaders.SALEABLE_PART_REV,
            ColumnHeaders.SALEABLE_PART_SUFFIX,
            ColumnHeaders.CUSTOMER_SALEABLE_PART_NUMBER,
            "",
            ColumnHeaders.LIFETIME_BUISINESS_VOLUME,
            ColumnHeaders.YEAR_ONE_BUISINESS_VOLUME,
            "",
            ColumnHeaders.PRICE_BREAKDOWN,
            ColumnHeaders.MATERIAL_YEAR_ONE,
            ColumnHeaders.FREIGHT_YEAR_ONE,
            ColumnHeaders.EXPENDABLE_DUNNAGE_YEAR_ONE,
            ColumnHeaders.DUTY_INBOUND_YEAR_ONE,
            ColumnHeaders.FREIGHT_WAREHOUSE_YEAR_ONE,
            ColumnHeaders.DUTY_OUTBOUND_YEAR_ONE,
            ColumnHeaders.DIRECT_LABOR_YEAR_ONE,
            ColumnHeaders.VARIABLE_BURDEN,
            ColumnHeaders.FIXED_BURDEN,
            ColumnHeaders.OPERATIONS_EXPENSE,
            ColumnHeaders.STARTUP,
            ColumnHeaders.OTHER_INCREMENTAL_COST,
            ColumnHeaders.WARRANTY,
            ColumnHeaders.OCOGS,
            ColumnHeaders.CURRENT_DEPRECIATION,
            ColumnHeaders.DEPRECIATION,
            ColumnHeaders.TOOLING_AMORTIZATION,
            ColumnHeaders.SG_AND_A,
            ColumnHeaders.ENGINEERING_TAX,
            "Sub Total",
            ColumnHeaders.PROFIT,
            ColumnHeaders.BUSINESS_CASE_FLOOR_ADJUSTMENT,
            "Total",
            "",
            ColumnHeaders.BUSINESS_CASE_FLOOR_PRICE,
            "",
            ColumnHeaders.INVESTMENT,
            ColumnHeaders.CAPITAL,
            ColumnHeaders.MFG_NON_REBILL_TOOLING,
            ColumnHeaders.VENDOR_NON_REBILL_TOOLING,
            ColumnHeaders.MFG_REBILL_ELIGIBLE_TOOLING,
            ColumnHeaders.VENDOR_REBILL_ELIGIBLE_TOOLING,
            ColumnHeaders.EXPENSE,
            "",
            ColumnHeaders.TOOLING_REBILL,
            "",
            ColumnHeaders.TOTAL_TOOLING_REBILL
        ];

        return header;
    }

    getDisplay(Headers, Records, Currency) {

        let display = [];

        display.push(Headers);

        let helper = new BaseModel();
        let costStudyAndVersions = []; //JG - Holds the Cost Study/Version that has already had its Total Tooling Rebill Formula set

        Records.forEach((record, index) => {
            let column = helper.excelLetter(index + 2)
            record.BusinessCaseFloorAdjustment = `=${column}40 - SUM(${column}35:${column}36)`;
            record.PriceBreakdownTotal = `=SUM(${column}35:${column}37)`;
            record.SubTotal = `=SUM(${column}16:${column}34)`

            let costStudyAndVersion = record.CostStudy + "|" + record.Version;

            if (costStudyAndVersions.indexOf(costStudyAndVersion) === -1) {
                let lengthOfCostStudyAndVersion = Records.filter(x => x.CostStudy == record.CostStudy && x.Version === record.Version).length;
                record.TotalToolingRebill = `=SUM(${column}50:${helper.excelLetter(lengthOfCostStudyAndVersion + index + 1)}50)`;
                costStudyAndVersions.push(costStudyAndVersion);
            }

            let row = [
                "",
                Currency,
                "",
                record.CostStudy,
                record.Version,
                record.OptionName,
                record.SaleablePartNumber,
                record.SaleablePartRev,
                record.SaleablePartSuffix,
                record.CustomerSaleablePartNumber,
                "",
                record.LifetimeBusinessVolume,
                record.Year1BusinessVolume,
                "",
                "",
                record.MaterialYear1,
                record.FreightInboundYear1,
                record.ExpendableDunnageYear1,
                record.DutyInboundYear1,
                record.FreightWarehouseOutboundYear1,
                record.DutyOutboundYear1,
                record.DirectLaborYear1,
                record.VariableBurden,
                record.FixedBurden,
                record.OperationsExpense,
                record.Startup,
                record.OtherIncrementalIncludesReach,
                record.Warranty,
                record.OCOGS,
                record.CurrentDepreciation,
                record.Depreciation,
                record.ToolingAmortization,
                record.SGandA,
                record.EngineeringInclResearchTax,
                record.SubTotal,
                record.Profit,
                record.BusinessCaseFloorAdjustment,
                record.PriceBreakdownTotal,
                "",
                record.BusinessCaseFloorPrice,
                "",
                "",
                record.CapitalAppliedToBC,
                record.MfgNonRebillTooling,
                record.VendorNonRebillTooling,
                record.MfgRebillEligibleTooling,
                record.VendorRebillEligibleTooling,
                record.Expense,
                "",
                record.ToolingRebill,
                "",
                record.TotalToolingRebill
            ];

            display.push(row);
        });

        return display[0].map((_, colIndex) => display.map(row => row[colIndex]));
    }

    getNumerics() {
        let numeric = [];

        return numeric;
    }
}

export class SaleableComparisonPartModel {
    CostStudy = "";
    Version = "";
    OptionName = "";
    SaleablePartNumber = "";
    SaleablePartRev = "";
    SaleablePartSuffix = "";
    CustomerSaleablePartNumber = "";
    LifetimeBusinessVolume = "";
    Year1BusinessVolume = "";
    MaterialYear1 = "";
    FreightInboundYear1 = "";
    ExpendableDunnageYear1 = "";
    DutyInboundYear1 = "";
    FreightWarehouseOutboundYear1 = "";
    DutyOutboundYear1 = "";
    DirectLaborYear1 = "";
    VariableBurden = "";
    FixedBurden = "";
    OperationsExpense = "";
    Startup = "";
    OtherIncrementalIncludesReach = "";
    Warranty = "";
    OCOGS = "";
    CurrentDepreciation = "";
    Depreciation = "";
    ToolingAmortization = "";
    SGandA = "";
    EngineeringInclResearchTax = "";
    Profit = "";
    BusinessCaseFloorAdjustment = "";
    PriceBreakdownTotal = "";
    BusinessCaseFloorPrice = "";
    CapitalAppliedToBC = "";
    MfgNonRebillTooling = "";
    VendorNonRebillTooling = ""
    MfgRebillEligibleTooling = ""
    VendorRebillEligibleTooling = ""
    Expense = ""
    ToolingRebill = "";
    TotalToolingRebill = ""
    SubTotal = "";

    constructor(version, snapshot, part, calculations, volumes) {

        let calculationHelper = new CalculationHelper();
        let partKey = calculationHelper.getPartKey(part);
        this.CostStudy = version.ECRNumber.Value.Fields[0];
        this.Version = version.Name;
        this.OptionName = snapshot?.GroupName;
        this.SaleablePartNumber = part.Part?.Number?.Fields[0] ?? "";
        this.SaleablePartRev = part.Part?.DrawingRevision?.Fields[0]?.Fields[0] ?? "";
        this.SaleablePartSuffix = part.Part?.Suffix?.Fields[0]?.Fields[0] ?? "";
        this.CustomerSaleablePartNumber = "";
        this.LifetimeBusinessVolume = volumes[partKey].total;
        this.Year1BusinessVolume = volumes[partKey].first;

        let partData = calculations.filter(item => { return item.partNumber === this.SaleablePartNumber && item.partRev === this.SaleablePartRev && item.partSuffix === this.SaleablePartSuffix && item.groupName === this.OptionName; })

        //JG: First Year Calcs
        this.MaterialYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.OUTSIDE_MATERIAL, line: CalcualtionResultKeys.OUTSIDE_MATERIAL }]);
        this.FreightInboundYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [
            { key: CalcualtionResultKeys.FREIGHT, line: CalcualtionResultKeys.PURCHASE_FREIGHT_COST },
            { key: CalcualtionResultKeys.FREIGHT, line: CalcualtionResultKeys.INTERPLANT_FREIGHT_COST },
            { key: CalcualtionResultKeys.WAREHOUSING, line: CalcualtionResultKeys.WAREHOUSE_COST },
            { key: CalcualtionResultKeys.WAREHOUSING, line: CalcualtionResultKeys.INTERPLANT_WAREHOUSE_COST },
            { key: CalcualtionResultKeys.PACKAGING, line: CalcualtionResultKeys.PACKAGING_COST },
            { key: CalcualtionResultKeys.PACKAGING, line: CalcualtionResultKeys.INTERPLANT_PACKAGIING_COST }
        ]);
        this.ExpendableDunnageYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.EXPENDABLE_DUNNAGE, line: CalcualtionResultKeys.EXPENDABLE_DUNNAGE }]);
        this.DutyInboundYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.INBOUND_DUTY }]);
        this.FreightWarehouseOutboundYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [
            { key: CalcualtionResultKeys.FREIGHT, line: CalcualtionResultKeys.OUTBOUND_FREIGHT_COST },
            { key: CalcualtionResultKeys.WAREHOUSING, line: CalcualtionResultKeys.OUTBOUND_WAREHOUSE_COST },
            { key: CalcualtionResultKeys.PACKAGING, line: CalcualtionResultKeys.OUTBOUND_PACKAGING_COST }
        ]);
        this.DutyOutboundYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.OTHER_COGS, line: CalcualtionResultKeys.OUTBOUND_DUTY_AFTER_DRAWBACK }]);
        this.DirectLaborYear1 = calculationHelper.firstYearCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.DIRECT_LABOR, line: CalcualtionResultKeys.DIRECT_LABOR }]);


        //JG: All Year Calcs
        this.VariableBurden = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.VARIABLE_MANUFACTURING, line: CalcualtionResultKeys.VARIABLE_MANUFACTURING }]);
        this.FixedBurden = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.FIXED_MANUFACTURING, line: CalcualtionResultKeys.FIXED_MANUFACTURING }]);
        this.OperationsExpense = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OPERATIONS_EXPENSE }]);
        this.Startup = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.STARTUP_LAUNCH_COST }]);
        this.OtherIncrementalIncludesReach = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.FACTORY_COST, line: CalcualtionResultKeys.OTHER_INCREMENTAL_COST_PER_UNIT }]);
        this.Warranty = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.WARRANTY_COST, line: CalcualtionResultKeys.WARRANTY_COST }]);
        this.OCOGS = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.OCOGS, line: CalcualtionResultKeys.OCOGS }]);
        this.CurrentDepreciation = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION, line: CalcualtionResultKeys.MANUFACTURING_DEPRECIATION_CURRENT }]);
        this.Depreciation = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.NEW_MANUFACTURING_DEPRECIATION, line: CalcualtionResultKeys.NEW_MANUFACTURING_DEPRECIATION }]);
        this.ToolingAmortization = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.AMORTIZATION, line: CalcualtionResultKeys.AMORTIZATION }]);
        this.SGandA = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.SG_AND_A, line: CalcualtionResultKeys.SG_AND_A }]);
        this.EngineeringInclResearchTax = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.ENGINEERING, line: CalcualtionResultKeys.ENGINEERING }]);
        this.Profit = calculationHelper.perPcCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.OPERATING_INCOME, line: CalcualtionResultKeys.OPERATING_INCOME }]);
        this.BusinessCaseFloorAdjustment = "";
        this.SubTotal = "";

        this.PriceBreakdownTotal = "";
        this.BusinessCaseFloorPrice = calculationHelper.firstYearCalculation(partData, volumes, partKey, [{ key: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES, line: CalcualtionResultKeys.OUTSIDE_PRODUCT_SALES }]);

        //JG: Investment Calcs
        this.CapitalAppliedToBC = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.PRORATED_CAPITAL, line: CalcualtionResultKeys.PRORATED_CAPITAL }]);
        this.MfgNonRebillTooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.MANUFACTURING_NON_REBILL_TOOLING, line: CalcualtionResultKeys.MANUFACTURING_NON_REBILL_TOOLING }]);
        this.VendorNonRebillTooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.VENDOR_NON_REBILL_TOOLING, line: CalcualtionResultKeys.VENDOR_NON_REBILL_TOOLING }]);
        this.MfgRebillEligibleTooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.MANUFACTURING_REBILL_TOOLING, line: CalcualtionResultKeys.MANUFACTURING_REBILL_TOOLING }]);
        this.VendorRebillEligibleTooling = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.VENDOR_REBILL_TOOLING, line: CalcualtionResultKeys.VENDOR_REBILL_TOOLING }]);
        this.Expense = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.EXPENSE_INVESTMENTS, line: CalcualtionResultKeys.EXPENSE_INVESTMENTS }]);
        this.ToolingRebill = calculationHelper.totalCalculation(partData, [{ key: CalcualtionResultKeys.TOOLING_REBILL, line: CalcualtionResultKeys.TOOLING_REBILL }]);
        this.TotalToolingRebill = "";
    }

}